import React from 'react';
import { industries } from '@/lib/industryData';
import { ShoppingBag, ShoppingCart, Store, Landmark, HeartPulse, HardHat, Building2, Plane } from 'lucide-react';

const iconMap = {
  ShoppingBag, ShoppingCart, Store, Landmark, HeartPulse, HardHat, Building2, Plane,
};

const IndustrySelector = ({ selected, onSelect }) => (
  <div className="bg-white border-b border-slate-200 shadow-sm">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
      <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-[0.18em] mb-3">Simular industria</p>
      <div className="grid grid-cols-4 sm:grid-cols-8 gap-2" data-testid="industry-selector">
        {industries.map(ind => {
          const Icon = iconMap[ind.iconName] || ShoppingBag;
          const isActive = selected === ind.id;
          return (
            <button
              key={ind.id}
              onClick={() => onSelect(ind.id)}
              data-testid={`industry-btn-${ind.id}`}
              className={`flex flex-col items-center gap-1.5 py-3 px-2 rounded-xl border text-center transition-all ${
                isActive
                  ? 'text-white shadow-lg scale-[1.03] border-transparent'
                  : 'bg-white text-slate-500 border-slate-150 hover:bg-slate-50 hover:border-slate-300'
              }`}
              style={isActive ? { backgroundColor: ind.accent, borderColor: ind.accent } : {}}
            >
              <Icon className="w-5 h-5 mx-auto" strokeWidth={isActive ? 2.5 : 1.8} />
              <span className="text-[10px] font-semibold leading-tight">{ind.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  </div>
);

export default IndustrySelector;

// Helper to get the lucide icon component by industry id
export const getIndustryIcon = (industryId) => {
  const ind = industries.find(i => i.id === industryId);
  if (!ind) return ShoppingBag;
  return iconMap[ind.iconName] || ShoppingBag;
};
